import React, { Component } from 'react';
import { Collapse } from 'react-bootstrap';
import { CCOAlert, FieldGroup, CCOButton, Option } from '../util/Components.js';
import { clone, update } from '../util/Utility.js';

class Help extends Component {

  constructor(props) {
    super(props);
    this.state = {
      help: null,
      networkAlert: false,
      saved: false,
    };
  }

  componentWillMount() {
    this.init(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps != this.props) {
      this.init(nextProps);
    }
  }

  init(props) {
    if (props.ministry.hasOwnProperty('help')) {
      this.setState({help: clone(props.ministry.help), base: clone(props.ministry.help)});
    }
    else {
      var newHelp = {
        on: false,
        description: ""
      }
      this.setState({help: clone(newHelp), base: clone(newHelp)});
    }
  }

  save() {

    var ministry = this.props.ministry;

    ministry.help = this.state.help;

    update('ministries/' + this.props.ministry.key, this, ministry).then(() => {
      this.setState({saved: true, base: clone(this.props.ministry.help)});
      setTimeout(() => {
        this.setState({saved: false});
      }, 3000);
    }).catch(() => {
      this.setState({networkAlert: true});
    });
  }

  render() {

    if (this.state.ministry === null) { return (<div />); }

    return (
      <center>
        <div style={{maxWidth: 500, padding: 10, textAlign: 'left'}}>
          <Option id="on" label="Ask for Help" text="This ministry needs more volunteers" context={this} comp="help" />
          <FieldGroup id="description" label="Description" placeholder="Enter text" help="What qualifications should the volunteers have or what kind of volunteer are you looking for?" context={this} comp="help" componentClass="textarea" />

          <FieldGroup id="signupLink" label="Link to Custum Sign-up Form" context={this} placeholder="https://www.example.com/signup" comp="help" help="The Sign Up button on your ministry page will take users to this URL." />

          <div style={{height: 20}} />
          <div style={{textAlign: 'center'}}>
            <CCOAlert in={this.state.saved} type="success" title="Saved" content="Your changes were saved successfully" />
            <CCOAlert in={this.state.networkAlert} type="danger" title="Network Error" content="Could not save because we could not connect to the server, please try again later." />
            <Collapse in={JSON.stringify(this.state.help) !== JSON.stringify(this.state.base)}><div>
              <CCOButton onClick={this.save.bind(this)} text="Save Changes" type="primary" />
            </div></Collapse>
          </div>

        </div>
      </center>
    );
  }
}

export default Help;



/** WEBPACK FOOTER **
 ** ./src/ministry/Help.js
 **/